import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { config } from '@/lib/env';
import { registerPreloadErrorHandler } from '@/lib/preload-reload';
import Root from '@/root';
import '@/index.css';

if (config.SENTRY_ENABLED) {
  Sentry.init({
    dsn: 'https://041ae82fc72340801fdda0b93f2481ea@sentry-prime.fast.onetrading.com/29',
    environment: config.APP_ENV,
    release: `bop-ui-v2@${__APP_VERSION__}`,
    sendDefaultPii: true,
    tunnel: config.IS_LOCAL ? '/sentry-tunnel' : undefined,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

registerPreloadErrorHandler();

// biome-ignore lint/style/noNonNullAssertion: #root is guaranteed by index.html
createRoot(document.getElementById('root')!).render(<Root />);
